import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'hellermanntyton',
} as IModuleProps;
